exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flag-right[data-v-15eb56f8] {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row-reverse;\n}", ""]);

// exports
